import api from '@/api/api';

const DOMAIN = '/dashboard';

const get = async (): Promise<Dashboard.Indicators> => {
	const { data } = await api.get(`${DOMAIN}/indicators`);
	return data;
};

const DashboardService = {
	get,
};

export { DashboardService };
